import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue';
import { useQuotationsStore } from '@/store/quotations';
import { format } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;
const store = useQuotationsStore();

const quotation = ref<any>(null);
const loading = ref(true);

onMounted(async () => {
  try {
    loading.value = true;
    quotation.value = await store.fetchQuotationById(props.id);
  } catch (e) {
    console.error('[Detail.vue] No se pudo cargar la actividad:', e);
  } finally {
    loading.value = false;
  }
});


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "pa-6" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, "Detalle de Cotización #" + _toDisplayString(_ctx.id), 1),
          _createVNode(_component_v_btn, {
            icon: "",
            class: "elevation-0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-close")
                ])),
                _: 1,
                __: [1]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(quotation.value), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})